export default {
  root: {
    class: ["flex items-stretch"],
  },
};
